module.exports = __webpack_public_path__ + "assets/img/CORREO.ab94ec73.svg";